import { useState, useEffect } from 'react'
import { useLanguage } from '../context/LanguageContext'

function Stars() {
  return (
    <div className="testimmonials_starts" style={{ marginTop: '16px' }}>
      {[...Array(5)].map((_, i) => (
        <i key={i} className="fas fa-star" style={{ color: '#f5a623', marginRight: '2px' }}></i>
      ))}
    </div>
  )
}

function SellSection() {
  const { t } = useLanguage()
  const [testimonials, setTestimonials] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/admin/texttestimonials')
      .then(r => r.json())
      .then(data => {
        setTestimonials(data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  if (loading || testimonials.length === 0) return null

  return (
    <div style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
      <style>{`
        .sell-heading-row {
          display: flex;
          flex-direction: row;
          gap: 15px;
          align-items: flex-end;
          flex-wrap: wrap;
        }
        .sell-heading-desc {
          flex: 0 1 400px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }
        @media (max-width: 768px) {
          .sell-heading-row { flex-direction: column; align-items: flex-start; gap: 12px; }
          .sell-heading-desc { flex: 1 1 auto; }
        }
      `}</style>
      <div style={{
        maxWidth: '1300px',
        margin: '0 auto',
        padding: '20px 20px 40px 20px',
        boxSizing: 'border-box',
      }}>
        <div className="sell-heading-row">
          <div style={{ flex: '1 1 auto' }}>
            <div style={{ marginBottom: '8px' }}>
              <span style={{
                backgroundColor: 'rgba(197,160,89,0.1)',
                color: '#C5A059',
                fontFamily: "'Poppins', sans-serif",
                fontSize: '12px',
                fontWeight: 700,
                borderRadius: '5px',
                padding: '5px 8px',
                display: 'inline-block',
              }}>{t('sellTestimonials.tag')}</span>
            </div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 'clamp(23px, 3.5vw, 44px)',
              fontWeight: 600,
              lineHeight: '1.2em',
              letterSpacing: '-0.3px',
              color: '#002E53',
              margin: 0,
              maxWidth: '550px',
            }}>
              {t('sellTestimonials.heading')}
            </h2>
          </div>
          <div className="sell-heading-desc">
            <p style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '1.6em',
              color: '#002E53',
              margin: 0,
            }}>
              {t('sellTestimonials.desc')}
            </p>
          </div>
        </div>
      </div>

      <div className="palmora-testimonials-grid" style={{
        maxWidth: '1300px',
        margin: '0 auto',
        padding: '0 20px 20px 20px',
        boxSizing: 'border-box',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '0px',
      }}>
        {testimonials.map((testimonial, i) => (
          <div key={i} style={{ width: '100%' }}>
            <div className="testimonial-container type_class_4" style={{
              padding: '45px 30px',
              borderRadius: '10px',
              boxShadow: '0px 2px 12px 0px rgba(0,0,0,0.02)',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              boxSizing: 'border-box'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                <div className="testimonial-image" style={{
                  backgroundImage: `url(${testimonial.image?.startsWith('data:image') || testimonial.image?.startsWith('http') ? testimonial.image : '/' + testimonial.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: '52px',
                  height: '52px',
                  borderRadius: '50%',
                  flexShrink: 0,
                }}></div>
                <div>
                  <div style={{
                    color: '#002E53',
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 600,
                    fontSize: '15px',
                  }}>{testimonial.author}</div>
                  <div style={{
                    color: '#002E53',
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: '13px',
                    fontWeight: 400,
                    opacity: 0.7,
                  }}>{testimonial.location}</div>
                </div>
              </div>
              <div style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: '15px',
                lineHeight: '1.6em',
                color: '#002E53',
                textAlign: 'left',
                flexGrow: 1,
              }}>{testimonial.text}</div>
              <Stars />
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 1024px) { .palmora-testimonials-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 600px)  { .palmora-testimonials-grid { grid-template-columns: repeat(1, 1fr) !important; } }
      `}</style>
    </div>
  )
}

export default SellSection
